import styles from '../ScriptItem.module.scss'

const ContentSection = ({ sectionNumber }) => (
  <h3 className={styles['script-item__section__header']}>
    {`Section ${String.fromCharCode(64 + sectionNumber)}`}
  </h3>
)
export default ContentSection
